/* eslint-env browser */

import * as React from 'react'
const PropTypes = require('prop-types')
const axios = require('axios')

const Counterpart = require('@gandi/counterpart').Instance
const translate = new Counterpart()
translate.registerTranslations('en', require('./i18n/en'))
translate.registerTranslations('fr', require('./i18n/fr'))

const ValidatedInput = require('../../custom/gunki-iron-tournament-2018-pre-registration/components/ValidatedInput')

function passwordIsValid(coupon) {
  return !!coupon && coupon.length > 3
}

class JoinContestWithPassword extends React.Component {
  constructor() {
    super()
    this.state = {
      wrongPassword: false,
      unknownError: false,
    }
    this.postRegister = this.postRegister.bind(this)
  }

  componentWillMount() {
    const { appConfig } = this.props
    if (appConfig.locale.identifierShort !== translate.getLocale()) {
      translate.setLocale(appConfig.locale.identifierShort)
    }
  }

  postRegister() {
    this.setState({ loading: true, unknownError: false, wrongPassword: false })

    const { contestId } = this.props
    const { password } = this.state

    axios
      .post(`/api/contests/${contestId}/register`, {
        password,
      })
      .then(() => {
        this.setState({ loading: false })
        window.alert(translate.translate('joinWithPassword.joinedAlert'))
        window.location.reload(true)
      })
      .catch(err => {
        if (err && err.response) {
          if (err.response.status === 400) {
            this.setState({ loading: false, wrongPassword: true })
            return
          }
        }
        this.setState({ loading: false, unknownError: true })
      })
  }

  render() {
    const { loading, password, wrongPassword, unknownError } = this.state
    const { isLoggedIn, contestRegistration } = this.props
    if (!isLoggedIn) {
      return (
        <div className="columns is-centered">
          <div className="column is-12-touch is-9-desktop has-text-centered">
            <p>
              <b>
                <span className="icon">
                  <i className="fas fa-exclamation-triangle has-text-warning" />
                </span>
                {translate.translate('joinWithPassword.pleaseLogin')}
                <br />
                <br />
              </b>
            </p>
          </div>
        </div>
      )
    }
    if (contestRegistration) {
      const showCheckListButton =
        ((window.webkit || {}).messageHandlers || {}).observe ||
        (window.AndroidMessageObserver || {}).showContestPermissionCheckList
      return (
        <div className="columns is-centered is-multiline is-mobile">
          <div className="column is-12-touch is-10-desktop">
            <span className="icon">
              <i className="fas fa-check has-text-primary" />
            </span>
            {translate.translate('joinWithPassword.alreadyJoined')}
            <div style={{ width: '100%', textAlign: 'center', paddingTop: 32 }}>
              {showCheckListButton && (
                <button
                  type="button"
                  className="button is-primary is-large"
                  onClick={() => {
                    if (((window.webkit || {}).messageHandlers || {}).observe) {
                      window.webkit.messageHandlers.observe.postMessage({ name: 'contest.showPermissionCheckList' })
                    }
                    if ((window.AndroidMessageObserver || {}).showContestPermissionCheckList) {
                      window.AndroidMessageObserver.showContestPermissionCheckList()
                    }
                  }}
                >
                  <span className="icon">
                    <i className="fas fa-check" />
                  </span>
                  &nbsp;CHECKLIST &gt;
                </button>
              )}
            </div>
          </div>
        </div>
      )
    }
    return (
      <div className="columns is-centered is-multiline is-mobile">
        <div className="column is-12 has-text-centered">
          <b>{translate.translate('joinWithPassword.joinText')}</b>
        </div>
        <div className="column is-8-touch is-4-desktop has-text-centered">
          <ValidatedInput
            initialValue=""
            placeholder="*********"
            label=""
            inputId="join-team-coupon"
            autoCorrect="off"
            autoCapitalize="off"
            valid={value => passwordIsValid(value)}
            forceUppercase
            onChange={value => this.setState({ password: (value || '').toUpperCase() })}
          />
        </div>
        <div className="column is-12 has-text-centered">
          <button
            type="submit"
            className={`button is-call-to-action ${loading ? 'is-loading' : ''}`}
            disabled={loading || !passwordIsValid(password)}
            onClick={this.postRegister}
          >
            {translate.translate('joinWithPassword.joinButton')}
          </button>
          <br />
          <p className="has-text-error p-2">
            {wrongPassword && translate.translate('joinWithPassword.wrongPassword')}
            {unknownError && translate.translate('joinWithPassword.unknownError')}
          </p>
        </div>
      </div>
    )
  }
}

JoinContestWithPassword.propTypes = {
  appConfig: PropTypes.object.isRequired,
  contestId: PropTypes.string.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  contestRegistration: PropTypes.object,
}

JoinContestWithPassword.defaultProps = {
  contestRegistration: undefined,
}

module.exports = JoinContestWithPassword
